<div class="change-request-list">
  <ng-container *ngIf="netChangesDeliverables$ | async as netChangesDeliverables">
    <ng-container *ngIf="netChangesDeliverables.length; else noChanges">
      <scope-by-work-table
        [scopeVersion]="(netChangesScopeVersion$ | async) || currentScope"
        [currentChangeRequest]="currentChangeRequest"
        [isEditable]="false"
        [showNetChanges]="true"
        [mainColumnClass]="mainColumnClass"
        [componentMainColumnClass]="componentMainColumnClass"
        [roleMainColumnClass]="roleMainColumnClass"
        [sortedSections]="sections"
        [sortedDefaultSectionDeliverables]="netChangesDeliverables"
        [cdnConfig]="cdnConfig" />
    </ng-container>
  </ng-container>

  <ng-template #noChanges>
    <div class="no-changes">
      <mat-icon class="material-symbols-rounded">info</mat-icon>
      <span>No net changes to display</span>
    </div>
  </ng-template>
</div>
